export var CHECKBOX_BORDER_WIDTH = 2;
export var INDETERMINATE_BAR_HEIGHT = 2;
export var INDETERMINATE_BAR_WIDTH = 14;
export var DEFAULT_RING_SIZE = 2;
export var HOVERED_RING_SIZE = 4;
export var CHECKED_RING_SIZE = 8;
export var INPUT_PADDING_DEFAULT = 8;
export var INPUT_PADDING_WITH_ICON = 36;
export var DEFAULT_BACKGROUND_COLOR = 'neutral0';
export var DEFAULT_COLOR = 'primary70';
export var DEFAULT_INVERTED_COLOR = 'primary40';
export var DEFAULT_TEXT_COLOR = 'neutral90';
export var DEFAULT_INVERTED_TEXT_COLOR = 'neutral0';
export var BORDER_COLOR = 'neutral50';
export var BORDER_INVERTED_COLOR = 'neutral20';
export var HOVER_COLOR = 'primary60';
export var HOVER_INVERTED_COLOR = 'primary30';
export var HOVER_BACKGROUND_COLOR = 'primary05';
export var HOVER_DETAILED_BACKGROUND_COLOR = 'primary90';
export var FOCUS_COLOR = 'primary80';
export var FOCUS_INVERTED_COLOR = 'primary50';
export var ERROR_DEFAULT_COLOR = 'red70';
export var ERROR_INVERTED_DEFAULT_COLOR = 'red40';
export var ERROR_HOVER_COLOR = 'red60';
export var ERROR_INVERTED_HOVER_COLOR = 'red30';
export var ERROR_FOCUS_COLOR = 'red80';
export var ERROR_INVERTED_FOCUS_COLOR = 'red50';
export var ERROR_HOVER_BACKGROUND_COLOR = 'red05';
export var ERROR_HOVER_DETAILED_BACKGROUND_COLOR = 'red90';
export var DISABLED_COLOR = 'neutral70';
export var DISABLED_BACKGROUND_COLOR = 'neutral20'; // Windows system color for disabled items in WHCM

export var WHCM_DISABLED_ITEM_COLOR = 'grayText'; // Windows system color for general items in WHCM

export var WHCM_ITEM_COLOR = 'canvasText';